import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import {
    formatHourInAMPMFormat,
    getDateFromISO,
    getDayOfWeekFullNameFromISO,
    getFourDigetYearFromISO,
    getMonthFromISO,
    getUserLocalTimeZone,
} from '../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../EventRegisterButton/EventRegisterButtonContainer';

import './SingleEventPageBottomCard.scss';

export default class SingleEventPageBottomCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * single event data
         */
        event: eventPropTypesShape.isRequired,
        /**
         * whether user is register for the event or not
         */
        isUserRegistered: PropTypes.bool.isRequired,
        /**
         * set userRegistered to true
         */
        setUserAsRegistered: PropTypes.func.isRequired,
    };

    static defaultProps = {
        event: {},
        setUserAsRegistered: () => {},
    };

    render() {
        const { isUserRegistered, setUserAsRegistered, event } = this.props;

        return (
            <div className="component-Events-SingleEventPageBottomCard">
                <FGBLabel>{this.props.event.eventType}</FGBLabel>
                <div className="bottom-card-title-section">
                    {this.props.event.title}
                </div>
                <NoSSR>
                    <div className="bottom-section-date-display">
                        {`${getDayOfWeekFullNameFromISO(
                            this.props.event.startTime
                        )} ${getMonthFromISO(
                            this.props.event.startTime
                        )} ${getDateFromISO(
                            this.props.event.startTime
                        )}, ${getFourDigetYearFromISO(
                            this.props.event.startTime
                        )} | ${formatHourInAMPMFormat(
                            this.props.event.startTime
                        )} - ${formatHourInAMPMFormat(
                            this.props.event.endTime
                        )} ${getUserLocalTimeZone()}`}
                    </div>
                </NoSSR>
                <div className="single-event-bottom-card-button-div">
                    <EventRegisterButtonContainer
                        event={event}
                        isUserRegistered={isUserRegistered}
                        setUserAsRegistered={setUserAsRegistered}
                        isSingleEventPage={true}
                    />
                </div>
            </div>
        );
    }
}
